export const SHOW_OVERLAY = "showOverlay";

export const HIDE_OVERLAY = `hideOverlay`;

export const HIDE_MODAL = "hideModal";

export const SHOW_MODAL = "showModal";

export const SHOW_MOBILE_SIDEBAR = "showMobileSidebar";

export const HIDE_MOBILE_SIDEBAR = "hideMobileSidebar";

export const SHOW_SIGN_UP_MODAL = "showSignUpModal";

export const HIDE_SIGN_UP_MODAL = "hideSignUpModal";
